import { HeaderValueGetterParams, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

import { TerritoryMapOmniCellRenderer } from 'app/components/AdvancedGrid/CellRenderers/TerritoryMapOmniCellRenderer/TerritoryMapOmniCellRenderer';

import { TmgRow } from 'app/models';

import { formatMessage } from 'utils/messages/utils';

export const territoryNameAndIdHeaderValueGetter = (params: HeaderValueGetterParams<TmgRow>) => {
  let count = 0;
  params.api?.forEachNodeAfterFilter((node) => {
    if (!node.group) count += 1;
  });
  return count === 0 ? formatMessage('TERRITORIES') : formatMessage('TERRITORIES_AND_COUNT', { count });
};

export const territoryNameAndIdCellRendererSelector = (
  params: ICellRendererParams<TmgRow>,
  onRecolorFinish: () => void
) => {
  if (params.node?.group) {
    return undefined;
  }

  return {
    component: TerritoryMapOmniCellRenderer,
    params: {
      onRecolorFinish
    }
  };
};

export const groupNameValueGetter = (params: ValueGetterParams<TmgRow>) => params.data?.groupForLevel?.name ?? null;

export const lockCellValueGetter = (params: ValueGetterParams<TmgRow>) => params.data?.isLocked;

export const ignoreCellValueGetter = (params: ValueGetterParams<TmgRow>) => params.data?.isIgnored;

export const getRowId = (params) =>
  `R::${params.data.groupForLevel?.territoryGroupId ?? 'no-group'}::${params.data.rule.ruleId}`;
